import { createSelector } from 'reselect';
import { SUBSCRIPTION_PLAN_BILLING_CYCLE_MONTHLY } from '../UserSubscriptionPlans/constants';

export const selectSubscriptionPlans = (state) => state.SubscriptionPlans;

export const selectEducatorSubscriptionPlans = createSelector(
  selectSubscriptionPlans,
  (subscriptionPlans) =>
    subscriptionPlans.filter((plan) => plan.get('type') === 'educator')
);

export const selectDefaultEducatorSubscriptionPlan = createSelector(
  selectEducatorSubscriptionPlans,
  (educatorPlans) =>
    educatorPlans.find(
      (plan) =>
        plan.get('billingCycle') === SUBSCRIPTION_PLAN_BILLING_CYCLE_MONTHLY
    )
);
